import httpRequest from 'httpRequest'
import { TipsSettingContract } from 'models/TipsSettingContract'

const TIPS_SETTINGS_PREFIX = '/location/tips-setting'
const tipsSettingService = {
    getTipsSetting: () =>
        httpRequest.get<TipsSettingContract>(TIPS_SETTINGS_PREFIX),
    updateTipsSetting: (id: string, contract: TipsSettingContract) => {
        return httpRequest.put(`${TIPS_SETTINGS_PREFIX}/${id}`, contract)
    },
}

export default tipsSettingService
